module.exports = __webpack_public_path__ + "static/media/workAntihumidity7.c6f76b35.jpg";